// src/components/NoProjectPage.jsx

import React from 'react';
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
} from '@mui/material';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';

export default function NoProjectPage({ logout }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            borderRadius: 3,
            px: { xs: 3, sm: 5 },
            py: { xs: 4, sm: 5 },
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              mx: 'auto',
              mb: 3,
              borderRadius: '50%',
              bgcolor: 'grey.100',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'text.secondary',
            }}
          >
            <SearchOffRoundedIcon sx={{ fontSize: 34 }} />
          </Box>

          <Typography
            variant="h1"
            sx={{
              mb: 1.5,
              fontSize: { xs: 24, sm: 28 },
              letterSpacing: '-0.5px',
            }}
          >
            No yearbook found
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              maxWidth: 390,
              mx: 'auto',
              mb: 2,
              lineHeight: 1.65,
            }}
          >
            We couldn’t find a yearbook connected to this email.
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              maxWidth: 430,
              mx: 'auto',
              mb: 4,
              lineHeight: 1.65,
            }}
          >
            Please try signing in with the email your school used for your
            child’s yearbook order. If you’re not sure which email was used,
            contact your school.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={logout}
            sx={{
              maxWidth: 320,
              py: 1.4,
            }}
          >
            Sign in with a different email
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}